import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  FilterFooter,
  FilterListbox,
  FilterOptionCheckbox,
  FilterPopover,
  type UseFilterMultipleReturn,
} from '@vtex/admin-ui'
import { BaseFilter } from '@/components/filters/BaseFilter/BaseFilter'
import { useFilterMultiple } from '@/components/filters/hooks/useFilterMultiple'
import { useSalesChannel } from '@/hooks/useSalesChannel'

interface FilterSalesChannelProps<T> {
  state: UseFilterMultipleReturn<T>
}

function FilterSalesChannelPopover<T>(props: FilterSalesChannelProps<T>) {
  const { state } = props

  const { data: salesChannels = [], isLoading } = useSalesChannel()

  useEffect(() => {
    state?.setStatus?.(isLoading ? 'loading' : 'ready')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return (
    <FilterPopover state={state}>
      <FilterListbox>
        {salesChannels.map((salesChannel) => (
          <FilterOptionCheckbox
            key={salesChannel.Id}
            id={String(salesChannel.Id)}
            label={salesChannel.Name}
          />
        ))}
      </FilterListbox>
      <FilterFooter />
    </FilterPopover>
  )
}

export type SerializedData = string[]

export function FilterSalesChannel(props: { name: string }) {
  const { formatMessage } = useIntl()

  return (
    <BaseFilter
      disclosureMessage={formatMessage({
        id: 'admin/admin.catalog.products-filter-sale-channel',
        defaultMessage: 'Sales channel',
      })}
      FilterPopoverComponent={FilterSalesChannelPopover}
      filterName={props.name}
      useFilterState={useFilterMultiple}
      toSerializableData={(data) =>
        (data.appliedItems?.map((item) => item.id) ?? []) as SerializedData
      }
    />
  )
}
